import { Iteration } from '@/service';

/**
 * @class @name Iteration
 * @description Exposes menu store module
 */
export default class IterationStore {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {};
	}

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	static get getters() {
		return {};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name getIteration
			 * @param {String} id
			 */
			async getIteration(context, id) {
				return Iteration.get(id);
			},

			/**
			 * @async @name saveIteration
			 * @param {String} id
			 */
			async saveIteration(context, payload) {
				return Iteration.add(payload);
			},

			/**
			 * @async @name getIteration
			 * @param {String} id
			 */
			async getIterationList(context, payload) {
				return Iteration.list(payload);
			},

			/**
			 * @async @name deleteIteration
			 * @param {String} id
			 */
			async deleteIteration(context, id) {
				return Iteration.delete(id);
			}
		};
	}
}
